/**
 * Created by seaasun on 2017/11/24.
 */
import Vue from 'vue'
import router from '../../router'
import main from './../../main'
import store from '../index'

export default {
  namespaced: true,
  state: {
    states: {},
    isInitState: false,
    isInitCitiesByState: false,
    // [{
    //   code: 'AL',
    //   name: 'Alabama',
    //   country: 'US'
    // }]
    map: null, // google map
    mapQuery: '',
    circle: [],
    radius: 0,
    geoTypes: {
      Unknown: { Code: 0, DisplayName: 'Unknown', Description: 'Unknown' },
      Country: { Code: 1, DisplayName: 'Country', Description: 'Country' },
      State: { Code: 2, DisplayName: 'State', Description: 'State' },
      County: { Code: 3, DisplayName: 'County', Description: 'County (State)' },
      City: { Code: 4, DisplayName: 'City', Description: 'City (State)' },
      Zip: { Code: 5, DisplayName: 'Zip', Description: 'ZIP (City)' },
      Ziprange: { Code: 6, DisplayName: 'Zip Range', Description: 'ZIP Range' },
      // Radius: { Code: 7, DisplayName: 'Radius', Description: 'Radius Around Single/Multi Address(es)' },
      Radius: { Code: 7, DisplayName: 'Radius', Description: 'Radius around an Address' },
      Scf: { Code: 8, DisplayName: 'SCF', Description: 'SCF' },
      ZipUpload: { Code: 9, DisplayName: 'ZipUpload', Description: 'ZipUpload' },
      Msa: { Code: 10, DisplayName: 'MSA', Description: 'Metro Area' },
      ZipRadius: { Code: 11, DisplayName: 'Zip Radius', Description: 'Radius around ZIP' },
      // Closex: { Code: 12, DisplayName: 'Closest Records', Description: 'Closest Records Single/Multiple Address(es)' },
      Closex: { Code: 12, DisplayName: 'Closest Records', Description: 'Closest Records to an Address' },
      Polygon: { Code: 13, DisplayName: 'Polygon Map', Description: 'Polygon Map' },
      MultiRadius: { Code: 14, DisplayName: 'Multi-Radius', Description: 'Radius around Multiple Addresses' },
      MultiClosex: { Code: 15, DisplayName: 'Multi-Closest Records', Description: 'Closest Records to Multiple Addresses' },
      AcxiomMultiRadius: { Code: 16, DisplayName: 'Multi-Radius', Description: 'Multi-Radius around Address' },
      AcxiomZipRadius: { Code: 17, DisplayName: 'Multi-ZipRadius', Description: 'Multi-Radius around Zip' },
      ZipMap: { Code: 18, DisplayName: 'Zip Map', Description: 'ZIP Codes or Carrier Routes from Map' },
      NationWide: { Code: 20, DisplayName: 'NationWide', Description: 'NationWide' },
      CongressionalDistrict: { Code: 22, DisplayName: 'Congressional-District', Description: 'Congressional District' },
      MultiGeo: { Code: 23, DisplayName: 'MultiGeo', Description: 'Multi Geo' },
      MultiCount: { Code: 24, DisplayName: 'MultiCount', Description: 'Multi Count' }
    },
    zipTypes: {
      zip: {
        code: 1,
        name: 'ZIP Code'
      },
      zip4: {
        code: 2,
        name: 'ZIP+4'
      },
      cr: {
        code: 3,
        name: 'Carrier Routes'
      }
    },
    geos: [],
    alertDesc: '',
    isLoadGoogleMap: false,
    geoUnAdd: false,
    catchZipBounders: {},
    isPolygonDrawing: false,
    allPolygonPoints: ''
  },
  getters: {
    geoType: (state) => (id) => {
      for (let key of Object.keys(state.geoTypes)) {
        let item = state.geoTypes[key]
        if (item.Code === parseInt(id)) {
          return item
        }
      }
      return {}
    }
  },
  mutations: {
    addState(state, item) {
      if (!state.states.hasOwnProperty(item.StateCode)) {
        Vue.set(state.states, item.StateCode, {
          code: item.StateCode,
          name: item.StateName,
          country: item.CountryCode
        })
      }
    },
    saveGeos(state, payload) {
      if (!(payload.geoType in state.geos)) {
        Vue.set(state.geos, payload.geoType, {})
      }
      Vue.set(state.geos[payload.geoType], payload.stateCode, payload.data)
    },
    saveMap(state, map) {
      state.map = map
    },
    saveMapQuery(state, query) {
      state.mapQuery = query
    },
    saveRadius(state, radius) {
      state.radius = radius
    },
    saveCircles(state, circles) {
      state.circle = circles
    },
    saveKey(state, val) {
      Vue.set(state, val[0], val[1])
    }
  },
  actions: {
    getStates({ state, commit }) {
      if (state.isInitState) {
        return false
      }
      commit('saveKey', ['isInitState', true])
      Vue.http.post('PlaceOrder.aspx/GetStates', {}).then(
        resp => {
          let data = resp.body.d.DataSource
          for (let item of data) {
            commit('addState', item)
          }
        },
        resp => {
          commit('saveKey', ['isInitState', false])
        })
    },
    next({ state, commit, dispatch, rootGetters, rootState }, isGo) {
      store.commit('geo/saveKey', ['geoUnAdd', false])
      commit('saveKey', ['alertDesc', ''])
      if (rootGetters['order/geos'].length > 0) {
        this.alertDesc = ''

        // Multi SLC Count
        if (rootGetters['order/currentGeoType'].isDirectCount) {
          dispatch('order/submitOrder', null, { root: true })

          // Normal
        } else if (rootGetters['order/hasDemoAndPhoneOption']) {
          dispatch('order/submitOrder', null, { root: true })

          // datasource 50
        } else if (rootGetters['order/ListType'] === 50) {
          main.$router.push({ name: 'demo' })
        } else {
          main.$router.push({ name: 'demo' })
        }
      } else {
        if (!isGo) {
          commit('saveKey', ['alertDesc', 'Please select at least one Geo Address'])
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/geo/index.js